module.exports = __webpack_public_path__ + "img/5.2a2fb3da.png";